export default __webpack_public_path__ + "assets/icons/chevron-route.1d13f8e3.svg";